import { backendApi } from "@/services/api";

const rulesApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    getInspectionRules: build.query<InspectionRule, GetInspectionRulesRequest>({
      query: (request) => ({
        url: `inspections/rules/inspection-rules/${request.processId}`,
        method: "GET",
      }),
      providesTags: ["Rules"],
    }),
  }),
});

export const { useGetInspectionRulesQuery } = rulesApi;

export interface GetInspectionRulesRequest {
  processId: string;
}

export interface InspectionRule {
  hasDifferentiation: boolean;
  hasActiveAirSampling: boolean;
  hasPassiveAirSampling: boolean;
}
